export default "__VITE_ASSET__DmFo$XN___"